import React from 'react';
import { Box, Text } from 'wt-ui';

const colors = {
  positive: { r: 101, g: 141, b: 27 },
  neutral: { r: 91, g: 103, b: 112 },
  negative: { r: 210, g: 38, b: 48 },
};
const getAlpha = (pct, percentColors) => {
  const range = 0.3;
  const min = percentColors[0].pct;
  const max = percentColors[2].pct;

  let res = 0;

  if (pct < 0) {
    res = (range * pct) / min;
  } else if (pct > 0) {
    res = (range * pct) / max;
  }

  return 0.7 + res;
};
const getColorForPercentage = (pct, percentColors) => {
  let i = 1;
  for (i = 1; i < percentColors.length - 1; i += 1) {
    if (pct < percentColors[i].pct) {
      break;
    }
  }
  const lower = percentColors[i - 1];
  const upper = percentColors[i];
  const range = upper.pct - lower.pct;
  if (range === 0) {
    return {
      ...colors.neutral,
      a: getAlpha(pct, percentColors),
    };
  }
  const rangePct = (pct - lower.pct) / range;
  const pctLower = 1 - rangePct;
  const pctUpper = rangePct;
  const color = {
    r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
    g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
    b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
    a: getAlpha(pct, percentColors),
  };
  return color;
};

const getBgColor = (chg) => {
  const min = -1;
  const max = 1;
  const percentColors = [
    { pct: min, color: colors.negative },
    { pct: 0, color: colors.neutral },
    { pct: max, color: colors.positive },
  ];

  const color = getColorForPercentage(chg, percentColors);
  return `rgba(${[color.r, color.g, color.b, color.a].join(',')});`;
};

const UnderlyingBox = ({ chg, name }) => (
  <Box pad="small" background={getBgColor(chg)} style={{ border: '1px solid #fff' }}>
    <Text color="#fff" margin={{ bottom: 'small' }}>
      {name}
    </Text>
    <Text color="#fff" style={{ textAlign: 'right' }}>
      {chg}%
    </Text>
  </Box>
);

export default UnderlyingBox;
